module.exports = __webpack_public_path__ + "img/track_milestone.f664d0a4.svg";